import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Topbar from '../Topbar';

const useStyles = makeStyles({
  logged: {
    marginTop: 56,
  },
  notLogged: {
    marginTop: 76,
  },
});

const AppLayout = props => {
  const { children } = props;
  const classes = useStyles();
  const isAuth = useSelector(state => state.authState.isAuthenticated);
  const { id } = useSelector(state => state.authState.business);

  return (
    <Grid container direction="column">
      <Grid item>
        <Topbar isAuth={isAuth} businessId={id} />
      </Grid>
      <Grid item className={isAuth && id ? classes.logged : classes.notLogged}>
        {children}
      </Grid>
    </Grid>
  );
};

AppLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AppLayout;
